module.exports = __webpack_public_path__ + "static/img/img-1.7f033db.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-1.png
// module id = NprT
// module chunks = 1